import React, { Component } from 'react';
import './DesignLanding.css';

import Car_With_Text from '../../../img/design_page/CarMap-WithText.png';

import DesignTeamModal from '../designmodal/DesignTeamModal';
import designTeams from '../designdata/designTeams';

export class DesignLanding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTeam: null,
    };
  }

  openModal = (team) => {
    this.setState({ activeTeam: team });
  };

  closeModal = () => {
    this.setState({ activeTeam: null });
  };

  navigateTo = (direction) => {
    const { activeTeam } = this.state;
    const currentIndex = designTeams.findIndex((t) => t.id === activeTeam.id);
    const nextIndex = (currentIndex + direction + designTeams.length) % designTeams.length;
    this.setState({ activeTeam: designTeams[nextIndex] });
  };

  renderHotspot = (team) => {
    const { top, left, width, height } = team.hotspot;

    return (
      <button
        key={team.id}
        type="button"
        className="car-team-hotspot"
        style={{
          top,
          left,
          width,
          height,
        }}
        onClick={() => this.openModal(team)}
        aria-label={team.modal.title}
      />
    );
  };

  render() {
    const { activeTeam } = this.state;

    return (
      <>
        <div className="main-car-map-container">
          <div className="car-map-wrapper">
            <img
              src={Car_With_Text}
              className="main-car-map"
              alt="Formula Electric car design map"
            />

            {designTeams.map(this.renderHotspot)}
          </div>
        </div>

        {activeTeam && (
          <DesignTeamModal
            team={activeTeam}
            onClose={this.closeModal}
            onPrev={() => this.navigateTo(-1)}
            onNext={() => this.navigateTo(1)}
          />
        )}
      </>
    );
  }
}

export default DesignLanding;